export default __webpack_public_path__ + "static/media/cv.0fcd9067.pdf";